module.exports = __webpack_public_path__ + "img/10-detail.1833e297.jpeg";